












































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { IUser } from '@/model/security';
import { v4 as uuidv4 } from 'uuid';

import {
    required,
    minLength,
    maxLength,
    email,
} from 'vuelidate/lib/validators';

import BaseTable from '@/components/Table/BaseTable.vue';
import BaseModalForm from '@/components/Form/BaseModalForm.vue';
import { ISensorDevice } from '@/model/meta';

export default Vue.extend({
    name: 'Users',
    metaInfo: {
        title: 'Пользователи системы',
    },
    components: {
        BaseTable,
        BaseModalForm,
    },
    methods: {
        ...mapActions('administration', {
            loadData: 'loadUsersGrid',
            loadSubData: 'loadDevicesForUser',
            loadSubDataGrid: 'loadDevicesSubGrid',
            createItem: 'createUser',
            deleteItem: 'deleteUser',
            updateItem: 'updateUser',
            resetForm: 'resetForm'
        }),
        editModalShow(selectObj: IUser): void {
            this.editMode = 'edit';
            this.formShow = true;
            this.selected = selectObj;
        },
        newModalShow(): void {
            this.editMode = 'new';
            this.formShow = true;
        },
        deleteModalShow(selectObj: IUser): void {
            this.selected = selectObj;
            this.deleteShow = true;
        },
        submitForm(editObj: IUser): void {
            if (this.editMode === 'new') {
                this.createItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            } else {
                this.updateItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            }
        },
        submitDeleteForm(editObj: IUser): void {
            this.deleteItem(editObj).then((result: boolean) => {
                if (result === true) this.closeModalForm();
            });
        },
        closeModalForm(): void {
            this.resetForm();
            this.formShow = false;
            this.deleteShow = false;
        },
        loadSubDataAction(loadforObj: IUser): void {
            this.loadSubData(loadforObj);
        },
    },
    computed: {
        ...mapGetters('administration', {
            allData: 'getUsersGrid',
            subDataSet: 'getChooseDevicesData',
            preloader: 'getPreloader',
            failLoading: 'getFailLoading',
            activeFormRequest: 'getActiveFormRequest',
            failedFormRequest: 'getFailedFormRequest',
        }),
        selectedLogin(): string {
            return this.selected === undefined ? '' : this.selected.login;
        },
        deleteMessage(): string {
            return (
                'Удалить выбранного пользователя(' + this.selectedLogin + ')?'
            );
        },
        formSettings(): Array<any> {
            return [
                {
                    name: 'lastName',
                    idPrefix: 'last-name',
                    labelText: 'Фамилия',
                    inputType: 'input',
                    placeholder: 'Введите фамилию пользователя',
                    errorText:
                        'Ошибка. Обязательный параметр. Минимум 2, максимум 50 символов.',
                    validations: {
                        required,
                        minLength: minLength(2),
                        maxLength: maxLength(50),
                    },
                },
                {
                    name: 'firstName',
                    idPrefix: 'first-name',
                    labelText: 'Имя',
                    inputType: 'input',
                    placeholder: 'Введите имя пользователя',
                    errorText:
                        'Ошибка. Обязательный параметр. Минимум 2, максимум 50 символов.',
                    validations: {
                        required,
                        minLength: minLength(2),
                        maxLength: maxLength(50),
                    },
                },
                {
                    name: 'middleName',
                    idPrefix: 'middle-name',
                    labelText: 'Отчество',
                    inputType: 'input',
                    placeholder: 'Введите отчество пользователя',
                    errorText: 'Ошибка. Максимальная длинна 50 символов.',
                    validations: {
                        maxLength: maxLength(50),
                    },
                },
                {
                    name: 'login',
                    idPrefix: 'login-name',
                    labelText: 'Логин',
                    inputType: 'input',
                    placeholder: 'Введите логин пользователя',
                    errorText:
                        'Ошибка. Обязательный параметр. Минимум 2, максимум 100 символов.',
                    validations: {
                        required,
                        minLength: minLength(2),
                        maxLength: maxLength(100),
                    },
                },
                {
                    name: 'password',
                    forNew: true,
                    idPrefix: 'password-name',
                    labelText: 'Пароль',
                    inputType: 'input',
                    additionalType: 'password',
                    placeholder: 'Введите пароль пользователя',
                    errorText: 'Ошибка. Минимум 5 символов.',
                    validations: {
                        required,
                        minLength: minLength(5),
                    },
                },
                {
                    name: 'email',
                    idPrefix: 'email-name',
                    labelText: 'Email',
                    inputType: 'input',
                    placeholder: 'Введите email пользователя',
                    errorText: 'Ошибка. Введите корректный email',
                    validations: {
                        email,
                        minLength: minLength(5),
                        maxLength: maxLength(100),
                    },
                },
                {
                    name: 'phone',
                    idPrefix: 'phone-name',
                    labelText: 'Телефон',
                    inputType: 'input',
                    placeholder: 'Введите телефон пользователя',
                    errorText: 'Ошибка. Минимум 2, максимум 100 символов.',
                    validations: {
                        minLength: minLength(2),
                        maxLength: maxLength(100),
                    },
                },
                {
                    name: 'isActive',
                    idPrefix: 'is-active',
                    labelText: 'Активность',
                    inputType: 'checkbox',
                    checkedValue: true,
                    uncheckedValue: false,
                    validations: {
                        required,
                    },
                },
                {
                    name: 'isAdmin',
                    idPrefix: 'is-admin',
                    labelText: 'Администратор',
                    inputType: 'checkbox',
                    checkedValue: true,
                    uncheckedValue: false,
                    validations: {
                        required,
                    },
                },
                {
                    name: 'availableDevices',
                    idPrefix: 'availableDevices-name',
                    labelText: 'Доступные устройства',
                    inputType: 'grid',
                    primaryKey: 'sensorDeviceId',
                    dataSet: this.subDataSet,
                    fields: this.detailFields,
                    validations: {},
                },
            ];
        },
    },
    mounted() {
        this.loadData();
        this.loadSubDataGrid();
    },
    data() {
        return {
            fields: [
                { key: 'lastName', label: 'Фамилия', sortable: true },
                { key: 'firstName', label: 'Имя', sortable: true },
                { key: 'middleName', label: 'Отчество', sortable: true },
                { key: 'login', label: 'Логин', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'phone', label: 'Телефон', sortable: true },
                { key: 'isActive', label: 'Активность', sortable: true },
                { key: 'isAdmin', label: 'Админ', sortable: true },
            ],
            detailArrayName: 'availableDevices',
            detailFields: [
                { key: 'code', label: 'Код', sortable: true },
                { key: 'name', label: 'Наименование', sortable: true },
                { key: 'description', label: 'Описание', sortable: true },
                { key: 'isActive', label: 'Активность', sortable: true },
                { key: 'latitude', label: 'Широта', sortable: true },
                { key: 'longitude', label: 'Долгота', sortable: true },
                { key: 'locality', label: 'Ближайший город', sortable: true },
            ],
            selected: undefined as undefined | IUser,
            formShow: false,
            deleteShow: false,
            editMode: 'new' as 'new' | 'edit',
            emptyObject: {
                userId: uuidv4(),
                firstName: undefined as string | undefined,
                lastName: undefined as string | undefined,
                middleName: undefined as string | undefined,
                login: undefined as string | undefined,
                password: undefined as string | undefined,
                email: undefined as string | undefined,
                phone: undefined as string | undefined,
                isActive: false,
                isAdmin: false,
                availableDevices: [] as Array<ISensorDevice>,
            },
        };
    }
});
